export enum UserRole {
  None = 0,
  Admin = 1,
  Creator = 2,
  Agent = 3,
  Research = 4,
  Scouting = 5,
  Casting = 6
}



export class User {
  id!: string;
  role!: UserRole;
  email!: string;
  firstName!: string;
  lastName!: string;
  phoneNumber!: string;
  authIdentity!: string;
  smsOptIn: boolean = true;

  salary?: number;
  lastLogin?: string;
  disabled?: boolean;

  iat!: number;
  exp!: number;
  jwt!: string;
  picture!: string;
}
